"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TriggerGroup = exports.TriggerType = exports.AdvanceTriggerIdentifiers = void 0;
/**
 * Advance system triggers for notifications.
 * Directly correlates to the triggers available in the database.
 */
var AdvanceTriggerIdentifiers;
(function (AdvanceTriggerIdentifiers) {
    // APPLICATIONS
    AdvanceTriggerIdentifiers["NEW_APPLICATION"] = "new-application";
    AdvanceTriggerIdentifiers["ASSIGNED_APPLICATION"] = "assigned-application";
    AdvanceTriggerIdentifiers["PRIORITISED_APPLICATION"] = "prioritised-application";
    AdvanceTriggerIdentifiers["SLA_TIMEOUT_EXCEEDED"] = "sla-timeout-exceeded";
    AdvanceTriggerIdentifiers["SLA_TIMEOUT_EXCEEDED_FACULTY"] = "sla-timeout-exceeded-faculty";
    // PRECEDENTS
    AdvanceTriggerIdentifiers["PRECEDENTS_DEACTIVATED"] = "precedents-deactivated";
    AdvanceTriggerIdentifiers["PRECEDENTS_EXPIRING"] = "precedents-expiring";
    AdvanceTriggerIdentifiers["PRECEDENTS_ACTIVATED"] = "precedents-activated";
    AdvanceTriggerIdentifiers["ASSIGNED_PRECEDENT"] = "assigned-precedent";
    // COGNITO
    AdvanceTriggerIdentifiers["COGNITO_EMAIL_VERIFICATION"] = "cognito-email-verification";
    AdvanceTriggerIdentifiers["COGNITO_FORGOT_PASSWORD"] = "cognito-forgot-password";
    // ARTICULATION ARRANGEMENTS
    AdvanceTriggerIdentifiers["ARTICULATION_ARRANGEMENTS_DEACTIVATED"] = "articulation-arrangement-deactivated";
    AdvanceTriggerIdentifiers["ARTICULATION_ARRANGEMENTS_ACTIVATED"] = "articulation-arrangement-activated";
    AdvanceTriggerIdentifiers["ARTICULATION_ARRANGEMENTS_EXPIRING"] = "articulation-arrangements-expiring";
})(AdvanceTriggerIdentifiers = exports.AdvanceTriggerIdentifiers || (exports.AdvanceTriggerIdentifiers = {}));
var TriggerType;
(function (TriggerType) {
    TriggerType["SYSTEM"] = "SYSTEM";
    TriggerType["MANUAL"] = "MANUAL";
})(TriggerType = exports.TriggerType || (exports.TriggerType = {}));
var TriggerGroup;
(function (TriggerGroup) {
    TriggerGroup["APPLICANT_FACING"] = "Applicant Facing";
    TriggerGroup["INTERNATIONAL_AGENT"] = "International Agent";
    TriggerGroup["INSTITUTION_STAFF"] = "Institution Staff";
    TriggerGroup["UAC_INTERNAL"] = "UAC Internal";
})(TriggerGroup = exports.TriggerGroup || (exports.TriggerGroup = {}));
//# sourceMappingURL=NotificationTrigger.types.js.map